import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { FileQuestion, Home, ArrowLeft } from 'lucide-react'
import { resolveRoute } from '@/lib/workspace'

function getHomePath(): string {
  const target = resolveRoute()
  if (target.kind === 'workspace') return '/dashboard'
  if (target.kind === 'admin') return '/admin'
  return '/'
}

export function NotFound() {
  const homePath = getHomePath()

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md p-6 text-center">
        <div className="flex justify-center mb-4">
          <FileQuestion className="h-12 w-12 text-muted-foreground" />
        </div>

        <h1 className="text-2xl font-bold mb-2">Page Not Found</h1>

        <p className="text-muted-foreground mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => window.history.back()} variant="outline">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>

          <Button asChild>
            <Link to={homePath}>
              <Home className="h-4 w-4 mr-2" />
              Home
            </Link>
          </Button>
        </div>
      </Card>
    </div>
  )
}
